import { Container, Row, Col, Table, Badge } from "react-bootstrap";

export default function CustomerCardApplePayments(props) {

	const timestampToDate = (timestamp) => {
		return new Intl.DateTimeFormat("ru-RU", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit"
		}).format(timestamp * 1000);
	}

	return (
		<Container fluid className="px-0">

			<Row className="m-0">
				<Col className="px-0">
					<h6 className="SFProDisplay-Bold m-0">
						Payments
					</h6>
				</Col>
			</Row>

			<Row className="pt-3 m-0">
				<Col className="px-0">
					<Table responsive>

						<thead>
							<tr className="border-top border-secondary">
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									ID
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Product ID
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Transaction ID
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Original transaction
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Purchase date
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Expires date
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Trial
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Valid
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Refunded
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Price
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Currency
								</th>
								<th className="opacity-50 fw-normal white-space-nowrap ps-0 pe-4">
									Test
								</th>
							</tr>
						</thead>

						<tbody className="border-top-0">
							{props.data.map((rec, i) => (
								<tr className="border-top border-secondary" key={i}>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.id}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.product_identifier}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.transaction_identifier}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.original_transaction}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.purchase_date && timestampToDate(rec.purchase_date)}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.expires_date && timestampToDate(rec.expires_date)}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.is_trial_period &&
											<Badge pill bg="info" className="text-primary fw-normal text-capitalize m-0">
												True
											</Badge>
										}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.valid
											?
											<Badge pill bg="success" className="text-dark-green fw-normal text-capitalize m-0">
												True
											</Badge>
											:
											"False"
										}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.refunded &&
											<Badge pill bg="danger" className="text-dark-red fw-normal text-capitalize m-0">
												True
											</Badge>
										}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.price}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.currency}
									</td>
									<td className="white-space-nowrap ps-0 pe-4">
										{rec.test &&
											<Badge pill bg="warning" className="text-dark-yellow fw-normal text-capitalize m-0">
												True
											</Badge>
										}
									</td>
								</tr>
							))}
						</tbody>

					</Table>
				</Col>
			</Row>

		</Container>
	);
}